import axios from "../../axiosInstance";

export const fetchMarketplaceCompanies = async (page, perPage, filter) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `user-martket-place-companies/get?page=${page}&perPage=${perPage}&name=${filter}`
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const createMarketplaceAccount = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`user-martket-place-companies/store`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateMarketplaceStatus = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(
      `user-martket-place-companies/update-status/${id}`
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateMarketplaceAccountName = async (id, data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(
      `user-martket-place-companies/edit/${id}`,
      data
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const deleteMarketplaceAccount = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`user-martket-place-companies/delete/${id}`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};
